<template>
	
	<div class="container-fluid">
		<div class="row additional-content-grid">
			<div class="col-sm-12 col-md-3 main-categories-wrap">
				<div class="main-categories w-100" v-if="categories">
					<a class="item px-3 py-2 d-block mb-2" v-for="item in categories" @click="openMainCategory(item)" :class="[{'active': item == currentMainCategory}, `order-${item.order}`]" :key="item.name">
						{{item.name | capitalize}}
					</a>
				</div>
			</div>
			<div class="col-sm-12 col-md-9" v-if="loading" :class="[`order-${currentMainCategory ? currentMainCategory.order : 1}`]">
				<div class="categories px-3 py-2 text-center">
					<div class="spinner-border"></div>
				</div>
			</div>
			<div class="col-sm-12 col-md-9" v-if="currentMainCategory && !loading" :class="[`order-${currentMainCategory.order}`]">
                <category-tree :root-category="currentMainCategory"></category-tree>
			</div>
            <div class="col-sm-12 col-md-9 category-list" v-if="!loading && !currentMainCategory">
				<div class="categories px-3 py-2">
			 		<p>Izberite predmet</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CategoryTree from './CategoryTree'

export default {
	components: {
        CategoryTree
	},
	data() {
		return {
            categories: undefined,
            currentMainCategory: undefined,
			loading: true,
		};
	},
	mounted() {
		this.getGroups();
	},
	methods: {
		getGroups() {
			
			this.loadCategory().then(data => {
				this.categories = data.children
				this.openMainCategory(this.categories[0])
			})

        },
        openMainCategory(item) {
			this.currentMainCategory = item
			
			if (!item.loaded) {
				this.loading = true
				this.loadCategory(item).then(() => {
					this.loading = false
				})
			}
		},
		loadCategory(category) {

			return new Promise((resolve, reject) => {

				if (category == undefined) {
					this.loading = true
				} else {
					Vue.set(category, 'loading', true)
				}

				let route = category !== undefined ? this.route('dodatna-gradiva', category.id) : this.route('dodatna-gradiva')
				axios.get(route).then(({ data }) => {

					if (category === undefined) {
						this.loading = false
					} else {
						// make reactive
						Vue.set(category, 'additionalContent', data.additionalContent)
						Vue.set(category, 'children', data.children)
						Vue.set(category, 'loaded', true)

						Vue.delete(category, 'loading')
					}

					resolve(data)

				})

			})

		}
	},
    filters: {
        capitalize(text) {
            return text.charAt(0).toUpperCase() + text.slice(1)
        }
	},
	provide() {
		return {
			loadCategory: this.loadCategory
		}
	}
};
</script>

<style scoped lang="scss">

@for $i from 1 through 10 {
	.order-#{$i} {
		order: #{$i};
	}
}
@media only screen and (max-width: 767px) {
  
	.main-categories,
	.main-categories-wrap {
		display: contents;
	}
	.item {
		display: block;
	}
	.additional-content-grid {
		display: flex;
		flex-direction: column;
	}
	@for $i from 1 through 10 {
		.order-#{$i} {
			padding-left: 0;
			padding-right: 0;
			margin-bottom: 0.5rem;
		}
	}
}

@media only screen and (min-width: 768px) {
  
	.main-categories{
		display: flex;
		flex-direction: column;
	}
}

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/AdditionalContent.vue